import { useEffect, useState } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";
import InnerLoader from '../ui/loader/inner-loader';
import { Link } from 'react-router';
import { File, UploadCloud } from 'lucide-react';

const CarModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, carData, vendors = [] }) => {
  const apiCall = useApiCall();

  const [logoError , setLogoError] = useState(false);
  const [imageError , setImageError] = useState(false);
  const [numberPlateError , setNumberPlateError] = useState(false);

  useEffect(() => {
    console.log("carData", carData);
    if (carData?.id) {
      formik.setFieldValue("vendor", carData?.vendor_id || "")
      formik.setFieldValue("carName", carData?.car_name || "")
      formik.setFieldValue("model", carData?.car_model || "")
      formik.setFieldValue("car_variant", carData?.car_variant || "")
      formik.setFieldValue("car_type", carData?.car_type  || "")
      formik.setFieldValue("registration", carData?.car_registraion || "")
      formik.setFieldValue("rent", carData?.car_rent || "")
      formik.setFieldValue("runningPart", carData?.car_running_part || "")
      formik.setFieldValue("carImage", carData?.car_image || "")
      formik.setFieldValue("numberPlate", carData?.car_number_plate_letter || "")
      formik.setFieldValue("is_active", carData?.status == "Active" ? "yes" : "no")
      formik.setFieldValue("is_auto", carData?.car_transmission == "A/T" ? "auto" : "manual")
    }
  }, [])

  const validationSchema = yup.object({
    vendor: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    model: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    registration: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    rent: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    is_auto: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    is_active: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    car_type: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    car_variant: yup.string("This Field is Required").required("This Field is Required")
  });

  const formik = useFormik({
    initialValues: {
      vendor: '',
      carName: '',
      model: '',
      car_variant: '',
      car_type : '',
      registration: '',
      rent: '',
      is_auto: '',
      runningPart: '',
      carImage: '',
      numberPlate: '',
      is_active: '',
      runningPartLoader: false,
      carImageLoader: false,
      numberPlateLoader: false
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      console.log("values", values)

      let extraData = {};

      if (carData?.id) {
        extraData = {
          "car_id": carData?.id
        }
      }

      let data = {
        ...extraData,
        "car_name": values?.carName,
        "car_model": values?.model,
        "car_variant" : values?.car_variant,
        "car_type": values?.car_type,
        "car_registraion": values?.registration,
        "vendor_id": values?.vendor,
        "car_rent": values?.rent,
        "car_transmission": values?.is_auto == "auto" ? "A/T" : "M/T",
        "car_image": values?.carImage,
        "car_status": values?.is_active == "yes" ? "1" : "0",
        "car_documents":{
          "running_part": values?.runningPart,
          "number_plate_letter": values?.numberPlate
        }
      }

      try {
        let apiRes = await apiCall({ method: "post", url: (carData?.id) ? `edit-car-fleet` : "add-car-fleet", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
      }

    },
  });

  const handleFileUpload = async (file, type) => {
    let apiData = new FormData();
    apiData.append('file', file);
    if(type == "runningPart"){
      setLogoError(false);
      formik.setFieldValue("runningPart", "");
      formik.setFieldValue("runningPartLoader", true);
    }else if(type == "carImage"){
      setImageError(false);
      formik.setFieldValue("carImage", "");
      formik.setFieldValue("carImageLoader", true);
    }else{
      setNumberPlateError(false);
      formik.setFieldValue("numberPlate", "");
      formik.setFieldValue("numberPlateLoader", true)
    }
    try {
      let apiRes = await apiCall({ method: "post", url: "upload", data: apiData });
      if(type == "runningPart"){
        formik.setFieldValue("runningPart", apiRes?.path?.filepath);
        formik.setFieldValue("runningPartLoader", false);
      }else if(type == "carImage"){
        formik.setFieldValue("carImage", apiRes?.path?.filepath);
        formik.setFieldValue("carImageLoader", false);
      }else{
        formik.setFieldValue("numberPlate", apiRes?.path?.filepath);
        formik.setFieldValue("numberPlateLoader", false)
      }
      console.log("apiRes", apiRes?.path?.filepath, type);
    } catch (error) {
      console.log("Error", error)
    }
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>{(carData?.id) ? "Update" : "Add"} Car</h4>
          <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Vendor</label>
                  <select name='vendor' value={formik.values.vendor} onChange={formik.handleChange}>
                    <option value="">-- Select Vendor --</option>
                    {vendors?.map((eachVendor, i) => (
                      <option value={eachVendor?.id} key={i}>{eachVendor?.name}</option>
                    ))}
                  </select>
                  {/* { } */}
                  {
                    (formik.touched.vendor && Boolean(formik.errors.vendor)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.vendor && formik.errors.vendor}</span>
                      :
                      null
                  }
                </div>
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Car Name</label>
                    <input
                      type="text"
                      name='carName'
                      min={1}
                      value={formik.values.carName}
                      onChange={formik.handleChange}
                      placeholder='Car Name'
                    />
                    {
                      (formik.touched.carName && Boolean(formik.errors.carName)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.carName && formik.errors.carName}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Model</label>
                    <input
                      type="text"
                      name='model'
                      min={1}
                      value={formik.values.model}
                      onChange={formik.handleChange}
                      placeholder='Model'
                    />
                    {
                      (formik.touched.model && Boolean(formik.errors.model)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.model && formik.errors.model}</span>
                        :
                        null
                    }
                  </div>
                </div>

                 <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Variant</label>
                    <input
                      type="text"
                      name='car_variant'
                      min={1}
                      value={formik.values.car_variant}
                      onChange={formik.handleChange}
                      placeholder='Variant'
                    />
                    {
                      (formik.touched.car_variant && Boolean(formik.errors.car_variant)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.car_variant && formik.errors.car_variant}</span>
                        :
                        null
                    }
                  </div>
                </div>

                 <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Type</label>
                    <select name="car_type" value={formik.values.car_type} onChange={formik.handleChange}>
                      <option value="" disabled selected>--select car type --</option>
                      <option value=" Crossover SUV"> Crossover SUV</option>
                      <option value="Hatchback">Hatchback</option>
                      <option value="Mini SUV">Mini SUV</option>
                      <option value="Pickup Truck">Pickup Truck</option>
                      <option value="Sedan">Sedan</option>
                      <option value="SUV">SUV</option>
                    </select>
                    {
                      (formik.touched.car_type && Boolean(formik.errors.car_type)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.car_type && formik.errors.car_type}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Registration</label>
                    <input
                      type="text"
                      name='registration'
                      min={1}
                      value={formik.values.registration}
                      onChange={formik.handleChange}
                      placeholder='Registration Number'
                    />
                    {
                      (formik.touched.registration && Boolean(formik.errors.registration)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.registration && formik.errors.registration}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Rent</label>
                    <input
                      type="text"
                      name='rent'
                      min={1}
                      value={formik.values.rent}
                      onChange={formik.handleChange}
                      placeholder='Rent'
                    />
                    {
                      (formik.touched.rent && Boolean(formik.errors.rent)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.rent && formik.errors.rent}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Transmission</label>
                    <div className="flex items-center gap-6">
                      <div className="flex items-center gap-1">
                        <input
                          className='!h-5'
                          type="radio"
                          name='is_auto'
                          checked={formik.values?.is_auto == "auto"}
                          id='activeAuto'
                          value={"auto"}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor="activeAuto" className='!h-5'>Automatic</label>
                      </div>

                      <div className="flex items-center gap-1">
                        <input
                          className='!h-5'
                          type="radio"
                          name='is_auto'
                          checked={formik.values?.is_auto == "manual"}
                          id='activeManual'
                          value={"manual"}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor="activeManual" className='!h-5'>Manual</label>
                      </div>
                    </div>
                    {
                      (formik.touched.is_auto && Boolean(formik.errors.is_auto)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.is_auto && formik.errors.is_auto}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Car Image</label>
                    <label
                      onDrop={(e) => { e.preventDefault(); handleFileUpload(e.dataTransfer.files?.[0], "carImage") }}
                      onDragOver={(e) => e.preventDefault()}
                      className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                    >
                      {formik?.values?.carImageLoader ?
                        <InnerLoader wrapperClass="!w-10 !h-10" textStatus={false} />
                        :
                        <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                      }
                      <p className="text-gray-600 font-medium">Drag & Drop files here</p>
                      <p className="text-sm text-gray-400">or click to browse</p>
                      <input
                        type="file"
                        onChange={(e) => { handleFileUpload(e.target.files[0], "carImage") }}
                        className="hidden"
                      />
                    </label>
                    {formik.values?.carImage ?
                      <div className="">
                        <Link to={formik.values?.carImage} target='_blank' className='inline-block'>
                          {imageError ?
                            <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              <File />
                            </div>
                            :
                            <img src={formik.values?.carImage} alt={formik?.values?.companyName} className='h-20 w-20 rounded-md' onError={(e) => {
                              e.target.classList.add("hidden");
                              setImageError(true);
                              // if (e.target.parentElement) {
                              //   e.target.parentElement.innerHTML =
                              //     `<div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              //       ${<File />}
                              //     </div>`
                              // }
                            }} />
                          }
                        </Link>
                      </div>
                      :
                      null
                    }
                    {
                      (formik.touched.carImage && Boolean(formik.errors.carImage)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.carImage && formik.errors.carImage}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Running Part</label>
                    <label
                      onDrop={(e) => { e.preventDefault(); handleFileUpload(e.dataTransfer.files?.[0], "runningPart") }}
                      onDragOver={(e) => e.preventDefault()}
                      className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                    >
                      {formik?.values?.runningPartLoader ?
                        <InnerLoader wrapperClass="!w-10 !h-10" textStatus={false} />
                        :
                        <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                      }
                      <p className="text-gray-600 font-medium">Drag & Drop files here</p>
                      <p className="text-sm text-gray-400">or click to browse</p>
                      <input
                        type="file"
                        onChange={(e) => { handleFileUpload(e.target.files[0], "runningPart") }}
                        className="hidden"
                      />
                    </label>
                    {formik.values?.runningPart ?
                      <div className="">
                        <Link to={formik.values?.runningPart} target='_blank' className='inline-block'>
                          {logoError ?
                            <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              <File />
                            </div>
                            :
                            <img src={formik.values?.runningPart} alt={formik?.values?.companyName} className='h-20 w-20 rounded-md' onError={(e) => {
                              e.target.classList.add("hidden");
                              setLogoError(true);
                              // if (e.target.parentElement) {
                              //   e.target.parentElement.innerHTML =
                              //     `<div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              //       ${<File />}
                              //     </div>`
                              // }
                            }} />
                          }
                        </Link>
                      </div>
                      :
                      null
                    }
                    {
                      (formik.touched.runningPart && Boolean(formik.errors.runningPart)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.runningPart && formik.errors.runningPart}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Number Plate Letter</label>
                    <label
                      onDrop={(e) => { e.preventDefault(); handleFileUpload(e.dataTransfer.files?.[0], "numberPlate") }}
                      onDragOver={(e) => e.preventDefault()}
                      className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                    >
                      {formik?.values?.numberPlateLoader ?
                        <InnerLoader wrapperClass="!w-10 !h-10" textStatus={false} />
                        :
                        <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                      }
                      <p className="text-gray-600 font-medium">Drag & Drop files here</p>
                      <p className="text-sm text-gray-400">or click to browse</p>
                      <input
                        type="file"
                        onChange={(e) => { handleFileUpload(e.target.files[0], "numberPlate") }}
                        className="hidden"
                      />
                    </label>
                    {formik.values?.numberPlate ?
                      <div className="">
                        <Link to={formik.values?.numberPlate} target='_blank' className='inline-block'>
                          {numberPlateError ?
                            <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              <File />
                            </div>
                            :
                            <img src={formik.values?.numberPlate} alt={formik?.values?.companyName} className='h-20 w-20 rounded-md' onError={(e) => {
                              e.target.classList.add("hidden");
                              setNumberPlateError(true);
                            }} />
                          }
                        </Link>
                      </div>
                      :
                      null
                    }
                    {
                      (formik.touched.numberPlate && Boolean(formik.errors.numberPlate)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.numberPlate && formik.errors.numberPlate}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Active</label>
                    {/* <input type="date" placeholder='Type Here' /> */}
                    <div className="flex items-center gap-6">
                      <div className="flex items-center gap-1">
                        <input
                          className='!h-5'
                          type="radio"
                          name='is_active'
                          checked={formik.values?.is_active == "yes"}
                          id='activeYes'
                          value={"yes"}
                          onChange={formik.handleChange}
                        // placeholder='Type is_active In Number'
                        />
                        <label htmlFor="activeYes" className='!h-5'>Yes</label>
                      </div>

                      <div className="flex items-center gap-1">
                        <input
                          className='!h-5'
                          type="radio"
                          name='is_active'
                          id='activeNo'
                          value={"no"}
                          checked={formik.values?.is_active == "no"}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor="activeNo" className='!h-5'>No</label>
                      </div>
                    </div>
                    {
                      (formik.touched.is_active && Boolean(formik.errors.is_active)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.is_active && formik.errors.is_active}</span>
                        :
                        null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default CarModal